import {
  GET_USER_COLOR,
  UPDATE_PROFILE,
  UPDATE_PROFILE_ERROR,
  DISSMISS_PROFILE_SUCCESS_MESSAGE,
  GET_ALL_COLORS,
} from '../../actions/profile';

export default function profile(state = {}, action) {
  switch (action.type) {
    case GET_USER_COLOR:
      return Object.assign({}, state, action.payload);
    case UPDATE_PROFILE:
      return Object.assign({}, state, action.payload);
    case UPDATE_PROFILE_ERROR:
      return Object.assign({}, state, action.payload);
    case DISSMISS_PROFILE_SUCCESS_MESSAGE:
      return Object.assign({}, state, action.payload);
    case GET_ALL_COLORS: 
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/profile/index.js